import React, { useEffect, useState, useCallback } from 'react'
import { Button, Tooltip, useMediaQuery, useTheme } from '@material-ui/core'
import { getLang } from '../../app/selectors/lang'
import useAddCompareLocations from '../hooks/useAddCompareLocations'
import { getRegionFromLocationId } from '../../app/selectors'
import useCompareStore from '../hooks/useCompareStore'
import { useLocationData, getLocationNameString } from '../../location'
import { fetchSimilarLocations } from '../utils'

const CompareLoadSimilarButton = (props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [state, setState] = useState({
    loading: false,
    loaded: false
  })

  const selectedLocation = useCompareStore(
    state => state.selectedLocation
  )
  const locationData = useLocationData(selectedLocation)
  const addCompareLocations = useAddCompareLocations()

  // reset disabled state if selected location changes
  useEffect(() => {
    setState({
      loading: false,
      loaded: false
    })
  }, [selectedLocation])

  const handleLoadSimilar = useCallback(() => {
    //fire analytics event
    window.dataLayer.push({event: 'similarPlacesComparison', geoTypeSelection: getRegionFromLocationId(locationData.id), locationId: locationData.id, locationName: getLocationNameString(locationData)})
    setState({ loading: true, loaded: false })
    fetchSimilarLocations(locationData.id).then(ids => {
      addCompareLocations(ids)
      setState({ loading: false, loaded: true })
    })
  }, [setState, addCompareLocations, locationData])

  const isStateLevel = locationData && getRegionFromLocationId(locationData.id) === 'states'

  return locationData ? (
    <Tooltip
      title={isStateLevel ? getLang('LOAD_SIMILAR_DISABLED') : getLang('LOAD_SIMILAR_HINT', {
        location: locationData.name
      })}>
      <span>
        <Button
          variant="outlined"
          disabled={state.loaded || isStateLevel}
          onClick={handleLoadSimilar}
          style={isMobile ? { width: "100%" } : null}
          {...props}>
          {state.loading
            ? getLang('LABEL_LOADING')
            : getLang('LOAD_SIMILAR_BUTTON')}
        </Button>
      </span>
    </Tooltip>
  ) : null
}

CompareLoadSimilarButton.propTypes = {}

export default CompareLoadSimilarButton
